module.exports = __webpack_public_path__ + "img/Project_Management.3af2c641.png";